import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AttributeDefinition } from 'src/app/models/server/attribute-definition';
import { ConnectedUsersStateService } from '../state/connected-users-state.service';
import { ServiceBase } from './service-base';

@Injectable({
    providedIn: 'root',
})
export class AttributeDefinitionsService extends ServiceBase {
    /**
     * Constructeur
     */
    constructor(
        private http: HttpClient,
        public override connectedUserStateService: ConnectedUsersStateService
    ) {
        super(connectedUserStateService);
    }

    /**
     * Liste les attributs d'une vue
     * @param viewId : Id de la vue
     * @returns Liste des attributs de la vue.
     */
    List(viewId: number): Observable<AttributeDefinition[]> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
        };

        // Appel de la Web Api
        return this.http.get<AttributeDefinition[]>(this.baseUrl + `/api/organizations/${this.organizationId}/views/${viewId}/attributes`, httpOptions);
    }

    /**
     * Retourne la liste les attributs système.
     * @returns Liste des attributs système.
     */
    ListSystemAttributes(): Observable<AttributeDefinition[]> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
        };

        // Appel de la Web Api
        return this.http.get<AttributeDefinition[]>(this.baseUrl + `/api/organizations/${this.organizationId}/systemAttributes`, httpOptions);
    }
}
